export default {"src":"/_next/static/media/GM.08042a43.svg","height":18,"width":18};